module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    attrs: {
      "id": "toc"
    }
  }, [_c('h1', {
    attrs: {
      "id": "toc-title"
    }
  }, [_vm._v("Sad, Sardonic and Hopeful")]), _vm._v(" "), _c('ol', {
    staticClass: "toc"
  }, [_c('li', {
    attrs: {
      "id": "toc-li-1"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch001#about-the-author"
    }
  }, [_vm._v("About the Author")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-2"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch002#dedication"
    }
  }, [_vm._v("Dedication")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-3"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch003#copyright-information"
    }
  }, [_vm._v("Copyright Information ©")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-4"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch004#acknowledgement"
    }
  }, [_vm._v("Acknowledgement")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-5"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch005#about-the-poet"
    }
  }, [_vm._v("About the Poet")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-6"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch006#be-kind",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Be Kind")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-7"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch007#the-song-has-lost-all-meaning",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Song has Lost all Meaning")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-8"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch008#home-improvement",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Home Improvement")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-9"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch009#a-letter-from-a-drowning-nation",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A Letter from a Drowning Nation")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-10"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch010#an-incompetent-announcement",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("An Incompetent Announcement")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-11"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch011#a-break-down-that-started-in-2018",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A Break Down (That Started in 2018)")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-12"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch012#trumpeting-clown",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Trumpeting Clown")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-13"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch013#gaia",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Gaia")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-14"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch014#foresight",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Foresight")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-15"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch015#missed-autumn",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Missed Autumn")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-16"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch016#an-indescribable-thing",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("An Indescribable Thing")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-17"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch017#false-pretences",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("False Pretences")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-18"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch018#a-great-showman",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A Great Showman")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-19"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch019#you",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("You")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-20"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch020#am-i",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Am I?")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-21"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch021#whispers",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Whispers")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-22"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch022#balloon",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Balloon")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-23"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch023#helpless",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Helpless")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-24"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch024#deep-blue",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Deep Blue")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-25"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch025#grumpelstiltskin",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Grumpelstiltskin")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-26"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch026#stone-cold",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Stone Cold")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-27"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch027#time",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Time")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-28"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch028#quantum",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Quantum")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-29"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch029#mummys-little-helper",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Mummy’s Little Helper")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-30"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch030#from-the-ears-of-babes",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("From the Ears of Babes")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-31"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch031#days-gone-by",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Days Gone By")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-32"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch032#no-more",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("No More")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-33"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch033#parlez-vous-anglais",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Parlez-Vous Anglais?")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-34"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch034#trick-or-treat",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Trick? Or Treat?")])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-41e49fa1","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/nav.vue
// module id = 60
// module chunks = 0